import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface mediaState {
  isOpen: boolean;
  scorecardUrl?: string | null;
  liveTvUrl?: string | null;
  showTv?: boolean;
  showScorecard?: boolean;
}

const initialState: mediaState = {
  isOpen: false,
  scorecardUrl: null,
  liveTvUrl: null,
  showTv: false,
  showScorecard: false,
};

export const mediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    openBetslip: (state) => {
      state.isOpen = true;
    },
    closeBetslip: (state) => {
      state.isOpen = false;
    },
    toggleBetslip: (state) => {
      state.isOpen = !state.isOpen;
    },
    setMediaUrls: (state, action: PayloadAction<{ scorecardUrl?: string; liveTvUrl?: string }>) => {
      state.scorecardUrl = action.payload.scorecardUrl;
      state.liveTvUrl = action.payload.liveTvUrl;
    },
    setShowTv: (state, action: PayloadAction<boolean>) => {
      state.showTv = action.payload;
    },
    setShowScorecard: (state, action: PayloadAction<boolean>) => {
      state.showScorecard = action.payload;
    },
    toggleTv: (state) => {
      state.showTv = !state.showTv;
      state.showScorecard = false;
    },
    toggleScorecard: (state) => {
      state.showScorecard = !state.showScorecard;
      state.showTv = false;
    },
  },
});

export const {
  openBetslip,
  closeBetslip,
  toggleBetslip,
  setMediaUrls,
  setShowTv,
  setShowScorecard,
  toggleTv,
  toggleScorecard,
} = mediaSlice.actions;
